import { render, staticRenderFns } from "./editDocument.vue?vue&type=template&id=326abc2f&"
import script from "./editDocument.vue?vue&type=script&lang=js&"
export * from "./editDocument.vue?vue&type=script&lang=js&"
import style0 from "./editDocument.vue?vue&type=style&index=0&id=326abc2f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports